import { Component } from "react";
import { AlertCircle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // If a WebSocket error fires after payment was already confirmed, suppress
    // the error boundary so the success screen remains visible to the customer.
    if (
      error?.message?.includes("WebSocket") &&
      sessionStorage.getItem("hdf_payment_ok")
    ) {
      sessionStorage.removeItem("hdf_payment_ok");
      return { error: null };
    }
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-brand-cream-50 rounded-3xl shadow-2xl p-8 max-w-sm w-full text-center flex flex-col items-center gap-4">
            <div className="w-16 h-16 bg-rose-50 rounded-full flex items-center justify-center">
              <AlertCircle className="w-8 h-8 text-rose-400" />
            </div>
            <div>
              <h3 className="font-display text-xl text-brand-forest-700 mb-1">Something went wrong</h3>
              <p className="font-body text-sm text-brand-forest-400">
                {this.props.message ?? "An unexpected error occurred. Please try again."}
              </p>
              {this.state.error && (
                <p className="font-body text-xs text-rose-400 mt-2 bg-rose-50 rounded-lg px-3 py-2 text-left break-words">
                  {this.state.error.message}
                </p>
              )}
            </div>
            <button
              onClick={() => {
                this.setState({ error: null });
                this.props.onReset?.();
              }}
              className="flex items-center gap-2 bg-brand-crimson-500 hover:bg-brand-crimson-600 text-white font-body text-sm px-6 py-2.5 rounded-full transition-colors"
            >
              <RefreshCw className="w-4 h-4" /> Try Again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
